import React, { useEffect, useState } from "react";
import "./MobileSidebar.css";

const MobileSidebar = ({ category, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
  if (category) {
    setTimeout(() => setIsOpen(true), 10);

    // Disable background scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  }

  return () => {
    // Re-enable scroll
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  };
}, [category]);


  useEffect(() => {
    if (category) {
      setTimeout(() => setIsOpen(true), 10); // trigger animation
    }
  }, [category]);

  if (!category) return null;

  return (
    <div className={`mobile-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <h3>{category.name}</h3>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="sidebar-content">
        {category.items.map((item, idx) => (
          <div key={idx} className="sidebar-section">
            <h4>{item.name}</h4>
            <ul>
              {item.subItems.map((sub, subIdx) => (
                <li key={subIdx}>{sub}</li>
              ))}
            </ul>
          </div>
        ))}

        <div className="sidebar-images">
          {category.images.map((img, i) => (
            <img key={i} src={img} alt={category.name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileSidebar;
